import React, { useState } from 'react';
import { Formik, Form as FormikForm } from 'formik';
import ErrorList from '../../errorList';
import { IFormProps } from './types';
import { IApiError } from '../../../services';

export const Form: React.FC<IFormProps> = ({
  initialValues,
  validationSchema,
  promise,
  children,
  onSubmit,
  onError
}) => {
  const [ajaxErrors, setAjaxErrors] = useState<Array<string>>([]);

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={(values, formikHelpers) => {

        setAjaxErrors([]);
        promise(values)
          .then(onSubmit)
          .catch((error: IApiError) => {
            setAjaxErrors(error.messages);
            formikHelpers.setSubmitting(false);

            if (onError) {
              onError(error, formikHelpers);
            }
          });
      }}
    >
      <FormikForm autoComplete="off">
        <ErrorList errors={ajaxErrors} />
        <div>{children}</div>
      </FormikForm>
    </Formik>
  );
};
